import * as React from 'react'
import {toDisplayDate} from '../../common/utils/dateUtils'
import {Box} from '../../webui/Box'
import {LockIcon} from '../../webui/icons/LockIcon'

interface Props {
  locked: boolean
  latestLockEventDate?: string
  latestLockEventLockedBy?: string
}

export const LockedCell: React.FC<Props> = ({locked, latestLockEventDate, latestLockEventLockedBy}) => {
  if (!locked) {
    return null
  }

  return (
    <Box alignItems={'center'} display={'inline-flex'} gap={1} title={latestLockEventLockedBy ? `Locked by ${latestLockEventLockedBy}` : undefined}>
      <LockIcon fill={'#334B55'} />
      {latestLockEventDate ? toDisplayDate(latestLockEventDate) : null}
    </Box>
  )
}
